import type { ConstructedDeliverable } from "@/types/types";

export default function getComputedDeliverableIdentifiers(deliverablesData: ConstructedDeliverable[]) {
    return deliverablesData.map(deliverable => {
        let editableGroupValueIds: string[] = [];
        const groupValues = Object.values(deliverable.combination ?? {});

        if (Array.isArray(groupValues)) {
            editableGroupValueIds = groupValues.map(groupValue => {
                const value = Object.values(groupValue).pop();

                if (!value) {
                    return "";
                }

                return value.groupValueId;
            });
        }

        return {
            editableGroupValueIds,
            language: deliverable.language,
            masterTemplateId: deliverable.masterTemplate._id
        };
    });
}
